import { default as folderTreeViewStateStore } from '../store/store';
import { select } from 'satcheljs/lib/legacy';
import createDragViewState from 'owa-dnd/lib/utils/createDragViewState';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import setFolderViewState from '../actions/setFolderViewState';
export default select({
    folderNodeViewStates: function () { return folderTreeViewStateStore.folderNodeViewStates; },
})(function getFolderViewStateFromId(folderId, state) {
    if (!state.folderNodeViewStates.has(folderId)) {
        setFolderViewState(folderId, {
            isExpanded: false,
            drag: createDragViewState(),
            drop: createDropViewState(),
        });
    }
    return state.folderNodeViewStates.get(folderId);
});
//# sourceMappingURL=getFolderViewStateFromId.js.map